import React, { useContext, useMemo } from 'react';
import styles from './RecordCompareGroup.module.scss';
import CompareContext, { CompareContextOverride } from '../RecordObject/RecordCompareContext';
import { Row } from '../Layout/RecordCompareLayout';
import stripHtml from '../../../utils/stripHtml';
import getOr from '../../../utils/getOr';
import RecordCompareStateContext from '../../RecordCompareStateContext';
export default function Group(_ref) {
  var property = _ref.property,
    children = _ref.children;
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView;
  var _useContext2 = useContext(CompareContext),
    mergeRecord = _useContext2.mergeRecord;
  var uiSchema = mergeRecord.uiSchema;
  var name = useMemo(function () {
    return stripHtml(getOr('')("".concat(property, ".ui:title.text"))(uiSchema));
  }, [uiSchema, property]);
  if (name === '') {
    return children;
  }
  if (cardView) {
    return /*#__PURE__*/React.createElement(CompareContextOverride, {
      groupName: name
    }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: styles['group-header']
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "group-container"
  }, children));
}